/**
 * Data migration registry.
 *
 * All migrations are registered here in priority order.
 * The runner iterates this array and executes each migration
 * that still needs to run.
 */

import type { DataMigration } from "./migrationTypes"
import { userStatusToStringMigration } from "./001-userStatus-to-string"
import { noteToDocMigration } from "./002-note-to-doc"
import { idbToSqliteMigration } from "./003-idb-to-sqlite"
import { dedupRecurringRemindersMigration } from "./004-dedup-recurring-reminders"

// ---------------------------------------------------------------------------
// Registry — ordered by priority (ascending)
// ---------------------------------------------------------------------------

export const dataMigrations: DataMigration[] = [
  userStatusToStringMigration,
  noteToDocMigration,
  idbToSqliteMigration,
  dedupRecurringRemindersMigration,
].sort((a, b) => a.priority - b.priority)
